import { render, staticRenderFns } from "./classify23.vue?vue&type=template&id=187c3ad8"
import script from "./classify23.vue?vue&type=script&lang=js"
export * from "./classify23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports